import { cn } from '@/lib/utils.js';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

const styles: Record<Variant, React.CSSProperties> = {
  primary: { background: 'var(--primary)', color: '#000', fontWeight: 600 },
  secondary: { background: 'var(--bg3)', color: 'var(--text)', border: '1px solid var(--border)' },
  ghost: { background: 'transparent', color: 'var(--text2)' },
  danger: { background: 'var(--bg3)', color: 'var(--feedback)', border: '1px solid var(--feedback)' },
};

export function Button({
  children,
  variant = 'primary',
  className,
  style,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  return (
    <button
      type="button"
      className={cn(className)}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        padding: '10px 16px',
        fontSize: 13,
        border: 'none',
        borderRadius: 8,
        cursor: props.disabled ? 'not-allowed' : 'pointer',
        opacity: props.disabled ? 0.6 : 1,
        ...styles[variant],
        ...style,
      }}
      {...props}
    >
      {children}
    </button>
  );
}
